'use client';
import React from 'react';
import type { ToastContextT } from '@/types/Toast';
import { ToastContext as Context } from '@/contexts/Toast';
import { ToastType } from '@/utils/constants';
import { notification } from 'antd';
import { getUniqueId } from '@/utils/common';

interface Props {
  children: React.ReactNode;
}

export const ToastProvider = ({ children }: Props) => {
  const [api, contextHolder] = notification.useNotification();

  const [type, setType] = React.useState<ToastType>();

  const [message, setMessage] = React.useState<string>();

  const [errors, setErrors] = React.useState<string[] | undefined>([]);

  const toggleToast: ToastContextT['toggleToast'] = React.useCallback(
    (args) => {
      setType(args.type);
      setMessage(args.message);
      setErrors(args.errors);
    },
    [],
  );

  const contextValue: ToastContextT = React.useMemo(
    () => ({ type, toggleToast, message, errors }),
    [type, toggleToast, message, errors],
  );

  React.useEffect(() => {
    if (type) {
      api.open({
        message,
        type,
        description:
          errors && errors.length > 0 ? (
            <div className="relative flex flex-col">
              {errors.map((item) => (
                <div
                  key={getUniqueId()}
                  className="text-[13px] my-2 text-red-500"
                >
                  {item}
                </div>
              ))}
            </div>
          ) : undefined,
        showProgress: true,
        pauseOnHover: true,
      });

      setTimeout(() => {
        setType(() => undefined);
      }, 1000);
    }
  }, [type, message, errors, api]);

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      {children}
    </Context.Provider>
  );
};
export default ToastProvider;
